module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wIJCCcA/KL7bQAAAHtJREFUOMvt1TEOgCAMBdDfhsMQ78Pk9XQQ7kP0MuDgRlCR1o2OJXklbZOS90uGchgAcG5WA0NYLxQA+NBBNwBcJlMkpEgimO8ekiUkS/09fYoS5j3L0Z4iLB1MrU1GitZ+ajSQz2gL0oz2YGqDGuhAX/aUJ/l1oT9u1Anl3yGCYK+SvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/flag.png
// module id = 255
// module chunks = 0